<template>
    <span>
        <span v-show="!IsPopperHidden">
            <slot></slot>
        </span>
        <slot name="reference">
        </slot>
        {{ checkPopperVisiblity }}
    </span>
</template>

<script>
    import Popper from 'popper.js';

    if ('ontouchstart' in document.documentElement) {
        document.body.style.cursor = 'pointer';
    }

    const on = (element, event, handler) => {
        if (element && event && handler) {
            if (document.addEventListener) {
                element.addEventListener(event, handler, false);
            } else {
                element.attachEvent(`on${event}`, handler);
            }
        }
    };
    const off = (element, event, handler) => {
        if (element && event) {
            if (document.removeEventListener) {
                element.removeEventListener(event, handler, false);
            } else {
                element.detachEvent(`on${event}`, handler);
            }
        }
    };

    export default {
        props: {
            hidePopperTooltip: {
                default: false,
            },
            showOnOver: {
                default: false,
            },
        },
        data() {
            return {
                IsPopperHidden: this.hidePopperTooltip,
                ShowOnOver: this.showOnOver,
                referenceElm: null,
                popper: null,
                popperInstance: null,
            };
        },
        computed: {
            // Dirty hack. They use "computed" property to keep an eye on the "hidePopperTooltip"
            // eslint-disable-next-line vue/return-in-computed-property
            checkPopperVisiblity() {
                this.IsPopperHidden = this.hidePopperTooltip;
            },
        },
        methods: {
            togglePopper() {
                this.IsPopperHidden = !this.IsPopperHidden;
                if (!this.IsPopperHidden) {
                    this.showPopper();
                } else {
                    this.hidePopper();
                }
            },
            showPopper() {
                this.createPopperInstance();
                this.$emit('showPopper', true);
            },
            hidePopper() {
                this.$emit('hidePopper', true);
                this.unsetPopper();
            },
            createPopperInstance() {
                this.popperInstance = new Popper(this.referenceElm, this.popper, {
                    modifiers: {
                        preventOverflow: {
                            padding: 0,
                            enabled: true,
                            boundariesElement: 'scrollParent',
                        },
                        flip: {
                            padding: 0,
                        },
                    },
                    inner: {
                        enabled: true,
                    },
                    placement: 'top',
                });
                this.popperInstance.scheduleUpdate();
            },
            handleDocumentClick(e) {
                if (this.checkElementFocus(e) !== 'popper') {
                    if (this.IsPopperHidden !== true) {
                        this.IsPopperHidden = true;
                        this.hidePopper();
                    }
                }
            },
            checkElementFocus(e) {
                let result = '';
                if (!this.$el || !this.referenceElm || this.elementContains(this.$el, e.target) || this.elementContains(this.referenceElm, e.target) || !this.popper || this.elementContains(this.popper, e.target)) {
                    result = 'popper';
                }
                return result;
            },
            elementContains(elm, otherElm) {
                if (typeof elm.contains === 'function') {
                    return elm.contains(otherElm);
                }
                return false;
            },
            destroyPopper() {
                off(this.referenceElm, 'click', this.togglePopper);
                off(document, 'click', this.handleDocumentClick);
                off(this.referenceElm, 'focus', this.togglePopper);
                off(document, 'focus', this.handleDocumentClick);
                if (this.ShowOnOver) {
                    off(this.referenceElm, 'mouseover', this.togglePopper);
                    off(document, 'mouseover', this.handleDocumentClick);
                }
                this.IsPopperHidden = true;
            },
            unsetPopper() {
                if (this.popperInstance !== null) {
                    this.popperInstance.destroy();
                    this.popperInstance = null;
                }
            },
            appendArrow() {
                const arrow = document.createElement('div');
                arrow.setAttribute('x-arrow', '');
                arrow.className = 'popper__arrow';
                this.popper.appendChild(arrow);
            },
            onMouseOut(e) {
                if (this.checkElementFocus(e) !== 'popper') {
                    clearTimeout(this._timer);
                    this._timer = setTimeout(() => {
                        if (this.IsPopperHidden !== true) {
                            this.IsPopperHidden = true;
                            this.hidePopper();
                        }
                    });
                }
            },
            checkDeviceOs() {
                const useragent = navigator.userAgent;
                if (useragent.match(/Android/i)) {
                    return 'android';
                }
                if (useragent.match(/webOS/i)) {
                    return 'webos';
                }
                if (useragent.match(/iPhone/i)) {
                    return 'iphone';
                }
                if (useragent.match(/iPod/i)) {
                    return 'ipod';
                }
                if (useragent.match(/iPad/i)) {
                    return 'ipad';
                }
                if (useragent.match(/Windows Phone/i)) {
                    return 'windows phone';
                }
                if (useragent.match(/SymbianOS/i)) {
                    return 'symbian';
                }
                if (useragent.match(/RIM/i) || useragent.match(/BB/i)) {
                    return 'blackberry';
                }
                return 'desktop';
            },
        },
        mounted() {
            this.referenceElm = this.$slots.reference[0].elm;
            this.popper = this.$slots.default[0].elm;
            on(this.referenceElm, 'click', this.togglePopper);
            on(document, 'click', this.handleDocumentClick);
            on(document, 'focusin', this.handleDocumentClick);
            if (this.ShowOnOver) {
                on(this.referenceElm, 'mouseover', this.togglePopper);
                on(document, 'mouseover', this.handleDocumentClick);
            }
            if (this.checkDeviceOs() !== 'desktop') {
                const modal = document.getElementsByClassName('help-me-calculate-modal')[0];
                on(modal, 'scroll', this.onMouseOut);
            }
            this.appendArrow();
        },
        destroyed() {
            this.destroyPopper();
            this.unsetPopper();
        },
    };

</script>
<style lang="scss">
.popper {
    width: auto;
    background-color: #fafafa;
    color: #212121;
    text-align: center;
    padding: 2px;
    display: inline-block;
    border-radius: 3px;
    position: absolute;
    font-size: 14px;
    font-weight: normal;
    border: 1px #ebebeb solid;
    z-index: 200000;
    -moz-box-shadow: rgb(58, 58, 58) 0 0 6px 0;
    -webkit-box-shadow: rgb(58, 58, 58) 0 0 6px 0;
    box-shadow: rgb(58, 58, 58) 0 0 6px 0;
}
.popper .popper__arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    }
.popper[x-placement^="top"] {
margin-bottom: 5px;
}
.popper[x-placement^="top"] .popper__arrow {
    border-width: 5px 5px 0 5px;
    border-color: #fafafa transparent transparent transparent;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}
.popper[x-placement^="bottom"] {
    margin-top: 5px;
}
.popper[x-placement^="bottom"] .popper__arrow {
    border-width: 0 5px 5px 5px;
    border-color: transparent transparent #fafafa transparent;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}
.popper[x-placement^="right"] {
    margin-left: 5px;
}
.popper[x-placement^="right"] .popper__arrow {
    border-width: 5px 5px 5px 0;
    border-color: transparent #fafafa transparent transparent;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}
.popper[x-placement^="left"] {
    margin-right: 5px;
}
.popper[x-placement^="left"] .popper__arrow {
    border-width: 5px 0 5px 5px;
    border-color: transparent transparent transparent #fafafa;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}
</style>
